import { Pipe, PipeTransform } from '@angular/core';

interface DistributionCenterType {
  site: {
    name: string;
  };
}

@Pipe({
  name: 'distributionCenterName',
})
export class DistributionCenterNamePipe implements PipeTransform {
  transform(distributionCenter: DistributionCenterType): string {
    return getDistributionCenterName(distributionCenter);
  }
}

export function getDistributionCenterName(distributionCenter: DistributionCenterType): string {
  if (!distributionCenter) {
    return null;
  }
  return distributionCenter.site ? distributionCenter.site.name : null;
}
